<template>
	<svg :alt="alt" width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M16.624 14.277H10.75V6.75H33.25V14.277H27.01V37.25H17.374V14.277H16.624Z" fill="white" stroke="#0074B5" stroke-width="1.5"/>
	</svg>
</template>

<script>
export default {
	props: {
		alt: String
	}
};
</script>
